import { useMutation, useQuery, useQueryClient } from "react-query";

import { GetProductsParams } from "../types";

import { deleteProduct, getProducts } from "./index";

export const useGetProducts = (params: GetProductsParams) => {
  return useQuery(["get-products", { ...params }], () => getProducts(params));
};

const useSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-products"] });
  };
};

export const useDeleteProduct = () => {
  const onSuccess = useSuccess();

  return useMutation(["delete-product"], deleteProduct, {
    onSuccess,
  });
};
